import script from "./FormulasIngredientSelectable.vue?vue&type=script&setup=true&lang=js"
export * from "./FormulasIngredientSelectable.vue?vue&type=script&setup=true&lang=js"

import "./FormulasIngredientSelectable.vue?vue&type=style&index=0&id=47d0a928&lang=scss"

const __exports__ = script;

export default __exports__